module.exports = __webpack_public_path__ + "static/icon-man-77199ba9ccb58c55c52fcb6983fbf6b2.png";